'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import Navbar from '../../../../../components/Navbar';
import Footer from '../../../../../components/Footer';
import InterestedPopup from '../../../../../components/InterestedPopup';
import { api } from '@/lib/apiClient';
import { useSearchParams } from 'next/navigation';
import Cookies from 'js-cookie';

// Mock Civil Details
const mockCivilDetails = {
    'civil-001': {
        id: 'civil-001',
        title: 'Professional Home Painting Service',
        providerName: 'Color World Decors',
        experience: '8 Years',
        jobsCompleted: '500+',
        description: 'We provide high-quality interior and exterior painting services. Our team consists of verified professionals who ensure dust-free experience and timely completion.',
        product_list: ['cement', 'bricks', 'blocks', 'sand', 'etc'],
        locality: 'Anna Nagar',
        city: 'Chennai',
    }
};
const contact = {
    agent: {
        contact_name: "John Doe",
        contact_role: "Manager"
    }
};

function convertToArray(str) {
    if (!str) return [];
    return str.split('-').map(num => parseInt(num, 10));
}

export default function CivilDetailPage() {
    const params = useParams();
    const propertyId = params.id;
    const [service, setService] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    //const service = mockCivilDetails[params.id] || mockCivilDetails['civil-001'];
    const [showInterestedPopup, setShowInterestedPopup] = useState(false);
    const [isLoggedInContext, setIsLoggedInContext] = useState(false);
    const searchParams = useSearchParams();
    const cityId = searchParams.get("cityId");
    const [localities, setLocalities] = useState("");
    const [user, setUserId] = useState("");
    const [parms, setParms] = useState("");

    //?${params}

    useEffect(() => {
        fetchProperty();
    }, [propertyId]);

    const fetchProperty = async () => {
        const user = await Cookies.get('id');
        if (user) {
            await setUserId(user.replace(/^"|"$/g, ''));
            setIsLoggedInContext(true);
            console.log("user", user);
        }
        const localitiesArray = convertToArray(searchParams.get("localities"));
        setLocalities(localitiesArray);
        let whereData = [1, cityId];
        try {
            const res = await api.post('selectwithout/view_admin_civil_suppliers', {
                sqlData: "*",
                where: "id=$1",
                whereData: [propertyId],
            }, { skipAuthGuard: true });
            if (res.success === 1 && Array.isArray(res.data) && res.data.length > 0) {
                setService(res.data[0]);

                const currentViews = res.data[0].views_count || 0;
                await api.post('updatewithout/suppliers/' + propertyId, { views_count: currentViews + 1 }, { skipAuthGuard: true });

            }
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <>
            <Navbar />
            <main className="min-h-screen pb-12">
                <div className="bg-white py-4">
                    <div className="container-custom">
                        <nav className="flex items-center gap-2 text-sm text-gray-500">
                            <Link href="/" className="hover:text-primary">Home</Link> <span>/</span>
                            <Link href="/civil-services" className="hover:text-primary">Civil Services</Link> <span>/</span>
                            <span className="text-gray-900 font-medium">{service.name}</span>
                        </nav>
                    </div>
                </div>

                <div className="container-custom">
                    <div className="grid lg:grid-cols-3 py-6 gap-8 items-start">
                        {/* Profile Header */}
                        <div className="lg:col-span-2">
                            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 mb-6">
                                <div className="flex items-start gap-6">
                                    <div className="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center text-3xl font-bold text-blue-600">
                                        {service.avatar}
                                    </div>
                                    <div className="flex-1">
                                        <h1 className="text-2xl font-bold text-gray-900 mb-1">{service.name}</h1>
                                        <p className="text-gray-500 font-medium mb-3">by {service.name} • {service.address}, {service.city}</p>

                                        <div className="flex items-center gap-6 text-sm">
                                            <div className="flex items-center gap-1 text-gray-600">
                                                <strong>{service.experience}</strong> Exp
                                            </div>
                                            {/* <div className="flex items-center gap-1 text-gray-600">
                                                <strong>{service.jobsCompleted}</strong> Jobs Done
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-8 pt-6 border-t border-gray-100">
                                    <h3 className="font-bold text-gray-900 mb-2">About the Service</h3>
                                    <p className="text-gray-600 leading-relaxed">{service.description}</p>
                                </div>
                            </div>

                            {/* Services List */}
                            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 mb-6">
                                <h3 className="font-bold text-xl text-gray-900 mb-6"> Product List </h3>
                                <div className="flex flex-wrap gap-3">
                                    {(service.services || []).map(s => (
                                        <div key={s} className="px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 font-medium capitalize">
                                            {s}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Portfolio */}
                            {/* <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                                <h3 className="font-bold text-xl text-gray-900 mb-6">Recent Work Portfolio</h3>
                                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                    {service.portfolio.map((item, idx) => (
                                        <div key={idx} className="group relative rounded-lg overflow-hidden h-40">
                                            <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform group-hover:scale-110" />
                                            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white text-sm font-bold">
                                                {item.title}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div> */}
                        </div>

                        {/* Booking Sidebar */}
                        <aside className="lg:col-span-1 space-y-6 lg:sticky lg:top-24">
                            {/* Rental Summary Card */}
                            <div className="bg-white rounded-2xl shadow-lg border border-primary/20 p-6 relative overflow-hidden">
                                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary to-purple-600"></div>

                                <h4 className="font-bold text-gray-900 mb-4 text-sm uppercase"> Contact </h4>
                                <div className="flex items-center gap-4 mb-6 mt-5">
                                    <div className="w-10 h-10 bg-gradient-to-br from-gray-700 to-gray-900 rounded-full flex items-center justify-center text-white text-lg font-bold shadow-md">
                                        {service.contact_name?.charAt(0)}
                                    </div>
                                    <div>
                                        <h5 className="font-bold text-gray-900">{service.contact_name}</h5>
                                        <p className="text-xs text-gray-500">{service.contact_role}</p>
                                    </div>
                                </div>

                                <button onClick={() => { setShowInterestedPopup(true); }} className="w-full btn btn-primary py-3.5 text-base font-bold shadow-primary/30 shadow-md mb-4">
                                    I'm Interested
                                </button>

                                <div className="pt-4 border-t border-gray-100 flex items-center justify-center gap-2 text-xs text-gray-400">
                                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                                    Your details are safe with us
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </main>

            <InterestedPopup
                isOpen={showInterestedPopup}
                onClose={() => setShowInterestedPopup(false)}
                loggedInPerson={isLoggedInContext}
                listingId={propertyId}
                mode="service"
                phone={service.contact_phone}
                agentName={service.contact_name}
                searchData={""}
            />
            <Footer />
        </>
    );
}
